import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Card, CardBody } from "reactstrap";

function WorkerDashboardHero({ displayName, isApproved, t }) {
  const welcomeMessage = isApproved
    ? t("workerDashboardWelcomeApproved", {
        name: displayName,
        defaultValue: `Welcome ${displayName}, your onboarding has been approved.`,
      })
    : t("workerDashboardWelcome", {
        name: displayName,
        defaultValue: `Welcome ${displayName}.`,
      });

  return (
    <Card className="worker-dashboard-hero border-0 mb-4">
      <CardBody className="p-4 p-lg-5">
        <h2 className="worker-dashboard-hero__title mb-0">{welcomeMessage}</h2>
      </CardBody>
    </Card>
  );
}

WorkerDashboardHero.propTypes = {
  displayName: PropTypes.string.isRequired,
  isApproved: PropTypes.bool.isRequired,
  t: PropTypes.func,
};

export default withTranslation()(WorkerDashboardHero);
